import settings from "../../constants/settings";
import useSWRFetcher, { SWRFetchError } from "./commonly-stored/fetcher";
import useSWR from "swr";
import { Closure } from "../../reducers/uploadedBoard";

export interface ManufacturingItem {
  board_id: string;
  shipment_id: string;
  ship_date: string;
}

export interface ManufacturingDashboard {
  items: ManufacturingItem[];
  shipment_history: ManufacturingItem[];
  dates_closed: Closure[];
}

export interface DashboardFilters {
  hide_blank_boards: boolean;
  has_panel: boolean;
  has_stencils: boolean;
  panels_not_yet_purchased: boolean;
  stencils_not_yet_purchased: boolean;
  parts_not_yet_purchased: boolean;
  show_manufactured_boards: boolean;
}

const DASHBOARD_URL = `${settings.api_url}/manufacturing/dashboard`;

export default function useManufacturingDashboard(
  filters?: DashboardFilters,
  keepStatic?: boolean,
) {
  const fetcher = useSWRFetcher<ManufacturingDashboard>();

  const url =
    filters === undefined
      ? DASHBOARD_URL
      : `${DASHBOARD_URL}?filters=${encodeURIComponent(JSON.stringify(filters))}`;

  const {
    data: dashboard,
    mutate,
    error,
    isValidating,
  } = useSWR<ManufacturingDashboard, SWRFetchError>(url, fetcher, {
    keepPreviousData: true,
    // TODO: when we are listening for the dashboard on a websocket, we can skip this
    revalidateOnFocus: !keepStatic,
  });

  return {
    dashboard: dashboard || null,
    loading: isValidating,
    refreshDashboard: () => void mutate(),
    errored: error !== undefined,
  };
}
